import axios from 'axios';

const API_ENDPOINT = '/api';

const API = {
  /**
   * @param {String} path
   * @param {String} [id]
   */
  fetch(path, id, params) {
    let uri = `${API_ENDPOINT}/${path}`;
    const options = {};

    if (id !== undefined) {
      uri = `${uri}/${id}`;
    }

    if (params !== undefined) {
      options.params = params;
    }

    return axios.get(uri, options);
  },

  submit(path, data, id) {
    let uri = `${API_ENDPOINT}/${path}`;

    if (id !== undefined) {
      uri = `${uri}/${id}`;
    }

    return axios.post(uri, data);
  },
};

export default API;
